import { useNavigate, useParams } from "react-router-dom";
import { useGetCallDetailsQuery } from "../../../../store/reservations/reservationsApi";
import moment from "moment";

const CallDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useGetCallDetailsQuery(id || "", {
    skip: !id,
  });

  const onGoBack = () => {
    navigate("/calls");
  };

  const callResponse = data?.data;
  return callResponse ? (
    <div className="w-full">
      <div className="flex flex-row items-center">
        <div data-qa={"back-button"} onClick={onGoBack} className=" mr-2">
          <img
            src={"/assets/shared/go-back.svg"}
            className={"w-[18px] object-contain cursor-pointer"}
          />
        </div>
        <p className="page-title pt-2">Call Details</p>
      </div>
      <div className="p-4 bg-white">
        <div className="w-full flex flex-wrap my-3">
          <h4 className="w-2/12">Summary</h4>
          <p className="w-10/12 pl-3 whitespace-pre-wrap break-words">
            {callResponse.summary}
          </p>
        </div>
        <div className="w-full flex flex-wrap my-3">
          <h4 className="w-2/12">Transcript</h4>
          <p className={"w-10/12 pl-3 whitespace-pre-wrap break-words"}>
            {callResponse.transcript}
          </p>
        </div>
        <div className="w-full flex flex-wrap my-5">
          <h4 className="w-2/12">Call Started</h4>
          <p className="w-10/12 pl-3">
            {moment(callResponse.callStarted).format("DD/MM/YYYY HH:mm:ss")}
          </p>
        </div>
        <div className="w-full flex flex-wrap my-5">
          <h4 className="w-2/12">Call Ended</h4>
          <p className="w-10/12 pl-3">
            {moment(callResponse.callEnded).format("DD/MM/YYYY HH:mm:ss")}
          </p>
        </div>
        <div className="w-full flex flex-wrap my-5">
          <h4 className="w-2/12">Ended Reason</h4>
          <p className="w-10/12 pl-3">{callResponse.endedReason}</p>
        </div>
        <div className="w-full flex flex-wrap my-5">
          <h4 className="w-2/12">Success Evaluation</h4>
          <p className="w-10/12 pl-3">{callResponse.successEvaluation}</p>
        </div>
        {Boolean(callResponse.structuredData) && <div className="w-full flex flex-wrap my-5">
          <h4 className="w-2/12">Title</h4>
          <p className="w-10/12 pl-3">{callResponse.structuredData.title}</p>
        </div>}
        <div className="w-full flex flex-wrap my-5">
          <h4 className="w-2/12 py-3">Recording Url</h4>
          <p className="w-10/12 pl-3">
            <audio controls>
              <source src={callResponse.recordingUrl} type="audio/wav"></source>
            </audio>
          </p>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default CallDetails;
